import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import {
  resetTimer,
  startTimer,
  updateStatus
} from '../../duck/operations'

import ampmeLogo from '../../assets/images/ampme-logo.png'

import { SongInformation } from './songInformation'

import Image from '../shared/image'
import Minimizer from '../shared/minimizer'

import { device } from '../../lib/deviceSizes'

const Main = styled.div`
  position: relative;
  height: 100%;
  max-height: 400px;
  width: 100%;
  max-width: 600px;

  border: 1px solid #f1f1f1;
  background-color: #ffffff;

  @media ${device.xSmall} {
    height: 99%; /* when embedded in a iframe, we want 1 px to display the border */
    width: 99%; /* when embedded in a iframe, we want 1 px to display the border */
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 20%;
  width: 100%;

  background-image: linear-gradient(245deg, #00fff2, #00b4fe);
`

const AmpMeLogo = styled(Image).attrs({
  src: ampmeLogo
})`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40%;
  max-width: 160px;
`

const SongInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 80%;
  width: 100%;
`


class PlayerComponent extends Component {
  componentWillUnmount() {
    this.props.resetTimer()
  }

  render() {
    return (
      <Main>
        <Minimizer />
        <Header>
          <AmpMeLogo source={this.props.song ? this.props.song.source : ''} />
        </Header>
        <SongInformationContainer>
          <SongInformation song={this.props.song} status={this.props.status}/>
        </SongInformationContainer >
      </Main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.status,
    song: state.song
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { resetTimer, startTimer, updateStatus }, dispatch)
}

export const Player = connect(mapStateToProps, mapDispatchToProps)(PlayerComponent)



// WEBPACK FOOTER //
// ./src/components/player/player.js